import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { DisposableSafelly } from "../../../disposable-safelly/disposable-safelly.component";
import { Subscription } from "rxjs";
import { AppState } from "../../../../interfaces/app-state.interface";
import { AdvisorEntity } from "../../../../entities/advisor.entity";
import { AdvisorAction } from "../../../../state-management/advisor/advisor.action";
import { AdvisorTypeEnum } from "../../../../models/Advisor";
import { ActionEventsEnum } from "../../../../enum/tracking/action-events.enum";
import { filter, map, tap } from "rxjs/operators";
import { AdvisorState } from "../../../../state-management/advisor/advisor.reducer";

@Component({
    selector: 'tr-advisor-inline',
    templateUrl: './advisor-inline.component.html',
    styleUrls: ['./advisor-inline.component.scss'],
})
export class AdvisorInlineComponent extends DisposableSafelly implements OnInit {

    @Input() public advisor: AdvisorEntity;
    public disposableSubscriptions: Subscription[] = [];

    constructor(private store: Store<AppState>, private element: ElementRef<HTMLElement>) {
        super();
    }

    public ngOnInit() {
        this.disposableSubscriptions.push(
            this.store
                .select((state) => state.advisor)
                .pipe(
                    map<AdvisorState, [AdvisorEntity, number]>((data, index) => [data.customerAdvisor, index]),
                    tap(([advisor, index]) => {
                        if (!advisor && index === 0) {
                            this.store.dispatch({
                                type: AdvisorAction.getAdvisor
                            })
                        }
                    }),
                    filter((data) => !!data)
                )
                .subscribe(([data]) => {
                    this.advisor = data;
                    this.store.dispatch(
                        this.advisor.getAnalyticsEvent(
                            ActionEventsEnum.LOADED_A_ELEMENT,
                            this.element.nativeElement.tagName.toLowerCase(),
                        )
                    )
                })
        );
    }

    public get isPotentialAdvisor() {
        return this.advisor.type === AdvisorTypeEnum.POTENTIAL;
    }
}